import script from "./TermsAndConditionsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TermsAndConditionsPage.vue?vue&type=script&setup=true&lang=js"

import "./TermsAndConditionsPage.vue?vue&type=style&index=0&id=5a502e9a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a502e9a"]])

export default __exports__